/** Type de données d'une cellule */
export enum DataTypeEnum {
    String = "String",
    Decimal = "Decimal",
    Boolean = "Boolean",
    Date = "Date",
    List = "List",
    Icon = "Icon",
    Custom = "Custom",       // Colonne étant définie par template à l'utilisation
}

/** Type de sélection (multiple ou simple) */
export enum SelectionTypeEnum {
    Multi = 0,
    Simple = 1,
}
